module.exports = __webpack_public_path__ + "assets/img/101302.2a210e73.png";